import { createPinia } from "pinia";
import { defineStore } from "pinia";

const useDevice = () => {
  return window.innerWidth > 768 ? { isMobile: false } : { isMobile: true };
};

export const useResolutionStore = defineStore(
  "resolution", // 해상도
  {
    state: () => ({
      resolution: {
        width: useDevice().isMobile ? 767 : 1920,
      },
    }),
    actions: {
      setSize(resolution) {
        this.resolution = resolution;
      },
    },

    getters: {
      isMobile(state) {
        return state.resolution.width < 768 ? true : false;
      },
      width(state) {
        return state.resolution.width;
      },
    },
  },
  { persist: false }
);
